module.exports = __webpack_public_path__ + "img/Recycle_pre.61c9b493.png";